import { render, staticRenderFns } from "./EntityTrees.vue?vue&type=template&id=96c20ef2&scoped=true&"
import script from "./EntityTrees.vue?vue&type=script&lang=js&"
export * from "./EntityTrees.vue?vue&type=script&lang=js&"
import style0 from "./EntityTrees.vue?vue&type=style&index=0&id=96c20ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c20ef2",
  null
  
)

export default component.exports